import type { ButtonProps } from '@chakra-ui/react';
import { Button, Spinner } from '@chakra-ui/react';
import type { ReactNode } from 'react';

type ConfirmButtonProps = Omit<ButtonProps, 'title'> & {
  title: ReactNode;
  isLoading: boolean;
  onClick: () => void;
  disabled: boolean;
};

export const ConfirmButton = ({
  title,
  isLoading,
  onClick,
  disabled,
  ...props
}: ConfirmButtonProps) => {
  return (
    <Button w="full" disabled={disabled} onClick={onClick} {...props}>
      {isLoading ? <Spinner /> : title}
    </Button>
  );
};
